import {ApiResponse} from '../models/ApiResponse';
import {
  GroupMember,
  LearnerGroup,
  LearnerGroupPayload,
} from '../models/Groups/LearnerGroup';
import {apiClient} from './baseApiClient';

class OrganizationGroupApi {
  public async getGroups(
    organizationId: string,
  ): Promise<ApiResponse<LearnerGroup[]>> {
    return apiClient.get(`/organizationGroup/${organizationId}/list`);
  }

  public async getGroupMembers(
    organizationId: string,
    groupId: string,
  ): Promise<ApiResponse<GroupMember[]>> {
    return apiClient.get(
      `/organizationGroup/${organizationId}/list_learners?groupId=${groupId}`,
    );
  }

  public async createGroup(
    organizationId: string,
    payload: LearnerGroupPayload,
  ): Promise<ApiResponse<{groupId: string}>> {
    return apiClient.post(`/organizationGroup/${organizationId}`, payload);
  }

  public async editGroup(
    organizationId: string,
    groupId: string,
    payload: LearnerGroupPayload,
  ): Promise<ApiResponse<any>> {
    return apiClient.put(
      `/organizationGroup/${organizationId}/${groupId}`,
      payload,
    );
  }

  public async deleteGroup(
    organizationId: string,
    groupId: string,
  ): Promise<ApiResponse<any>> {
    return apiClient.delete(`/organizationGroup/${organizationId}/${groupId}`);
  }

  public async addLearners(
    organizationId: string,
    groupId: string,
    learnerIds: string[],
  ): Promise<ApiResponse<any>> {
    return apiClient.post(`/organizationGroup/${organizationId}/add_learners`, {
      groupId,
      learnerIds,
    });
  }

  public async removeLearners(
    organizationId: string,
    groupId: string,
    learnerIds: string[],
  ): Promise<ApiResponse<any>> {
    return apiClient.post(
      `/organizationGroup/${organizationId}/${groupId}/remove_learners`,
      {learnerIds},
    );
  }

  public async enrollGroup(
    organizationId: string,
    groupId: string,
    publishedCourseId: string,
    dueDate?: Date,
  ): Promise<ApiResponse<any>> {
    return apiClient.post(
      `/organizationGroup/${organizationId}/${groupId}/course/${publishedCourseId}/enroll`,
      {dueDate: dueDate ?? null},
    );
  }
}

export default OrganizationGroupApi;
